import { OrderPayload } from 'lib/core/data/quote/placeOrder'
import axios, { AxiosResponse } from 'axios'
import { ServiceDependencies } from 'lib/core/services/magento'
import { getHeaders } from 'lib/core/services/magento/client/utils'

type PlaceMineOrderMutationInput = OrderPayload

export type PlaceMineOrderMutation = (input: PlaceMineOrderMutationInput) => Promise<AxiosResponse<any>>

export const createPlaceMineOrderMutation = (deps: ServiceDependencies): PlaceMineOrderMutation => async ({ payload }) => {
  return axios.put('/V1/carts/mine/order', payload, {
    headers: getHeaders(),
    responseType: 'text'
  })
}
